<template>
  <div>
    <b-embed
      type="iframe"
      aspect="16by9"
      :src="route_link"
      allowfullscreen
    ></b-embed>
  </div>
</template>

<script>
import { BEmbed } from "bootstrap-vue";

export default {
  props: {
    movie_id: {
      type: String,
      default: "1",
    },
    title: {
      type: String,
      default: "movie_title",
    },
  },
  computed: {
    route_link() {
      const formattedTitle = this.title.replace(/\s+/g, "-");
      return `${this.MOVIE_WEBSITE_BASE_URL}/${formattedTitle}/${this.movie_id}`;
    },
  },
  data() {
    return {
      MOVIE_WEBSITE_BASE_URL: process.env.VUE_APP_MOVIE_WEBSITE,
    };
  },
  components: {
    BEmbed,
  },
};
</script>
